var _mask, _path, _mask2, _path2, _mask3, _path3, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 213,
    viewBox: "0 0 10 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_612_419",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 212.333L0 202.333H10L10 212.333H0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 212.333H-1V213.333H0L0 212.333ZM0 202.333L0 201.333H-1L-1 202.333H0ZM10 202.333H11V201.333H10V202.333ZM10 212.333V213.333H11V212.333H10ZM0 212.333H1L1 202.333H0H-1L-1 212.333H0ZM0 202.333L0 203.333H10L10 202.333V201.333H0L0 202.333ZM10 202.333H9L9 212.333H10H11L11 202.333H10ZM10 212.333V211.333H0L0 212.333L0 213.333H10V212.333Z",
    fill: "#7CAF92",
    mask: "url(#path-1-inside-1_612_419)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_612_419",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 186.333L0 176.333H10L10 186.333H0Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 186.333H-1V187.333H0L0 186.333ZM0 176.333L0 175.333H-1L-1 176.333H0ZM10 176.333H11V175.333H10V176.333ZM10 186.333V187.333H11V186.333H10ZM0 186.333H1L1 176.333H0H-1L-1 186.333H0ZM0 176.333L0 177.333H10L10 176.333V175.333H0L0 176.333ZM10 176.333H9L9 186.333H10H11L11 176.333H10ZM10 186.333V185.333H0L0 186.333L0 187.333H10V186.333Z",
    fill: "#7CAF92",
    mask: "url(#path-3-inside-2_612_419)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_612_419",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 160.333L0 150.333H10L10 160.333H0Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 160.333H-1V161.333H0L0 160.333ZM0 150.333L0 149.333H-1L-1 150.333H0ZM10 150.333H11V149.333H10V150.333ZM10 160.333V161.333H11V160.333H10ZM0 160.333H1L1 150.333H0H-1L-1 160.333H0ZM0 150.333L0 151.333H10L10 150.333V149.333H0L0 150.333ZM10 150.333H9L9 160.333H10H11L11 150.333H10ZM10 160.333V159.333H0L0 160.333L0 161.333H10V160.333Z",
    fill: "#7CAF92",
    mask: "url(#path-5-inside-3_612_419)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 134.333,
    x2: 4.5,
    stroke: "#95D2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDesign);
export default __webpack_public_path__ + "static/media/side-design.b70a1466445edd8ec6bb76219e3ff93c.svg";
export { ForwardRef as ReactComponent };